export default "/images/vendor/flag-icons/flags/4x3/pc.svg?d669f78a433eced98974e596ceedc9ec";